export default {
  "content": "<g clip-path=\"url(#icon_emptystate_upgrade_svg__a)\"><path fill-rule=\"evenodd\" d=\"M3.655 6.744V4.52c0-2.497 2.01-4.52 4.49-4.52 2.48 0 4.49 2.023 4.49 4.519v2.225h1.122a.79.79 0 01.788.793v7.67a.79.79 0 01-.788.793H2.532a.789.789 0 01-.787-.792V7.537a.79.79 0 01.787-.793h1.123zm6.735 0V4.52a2.252 2.252 0 00-2.245-2.26A2.252 2.252 0 005.9 4.52v2.225h4.49zm-2.244 5.952a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"icon_emptystate_upgrade_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};